/*
 * @Author: wangkg wangkegui@longfor.com
 * @Date: 2022-12-23 07:40:55
 * @LastEditors: wangkg wangkegui@longfor.com
 * @LastEditTime: 2022-12-23 07:43:48
 * @FilePath: /unified-development-platform/src/store/modules/app.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */


const getAppId = () => {
  return process.env.VUE_APP_ID
}
const getAppObj = () => {
  return JSON.parse(sessionStorage.getItem('appObj'))
}

const getDefaultState = () => {
  return {
    appId: getAppId(),
    appObj: getAppObj(),
  }
}


const state = getDefaultState()

const mutations = {
  

}

const actions = {
  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
